import { GlobalConfig } from 'ngx-toastr';
import { ToastComponent } from '../components/toast/toast.component';

export const TOASTR_GLOBAL_CONFIG: Partial<GlobalConfig> = {
  timeOut: 5000,
  positionClass: 'toast-custom-position',
  toastClass: 'custom-toast',
  toastComponent: ToastComponent,
  iconClasses: {
    success: 'toast-no-icon',
    error: 'toast-no-icon',
    info: 'toast-no-icon',
    warning: 'toast-no-icon',
  },
};
